import DeleteAccountPage from "./delete.page";

export default DeleteAccountPage;
